// ========================
// == Map infowindow dismiss: close the hover infowindow once the pointer leaves the card
// == or marker that opened it. The infowindow is a link, so a short delay lets the pointer
// == cross into it, and hovering it keeps it open.

/** @type {number} */
const CLOSE_DELAY_MS = 250;
/** The infowindow container: oilib's SmartInfoWindow on search maps, Google's native one elsewhere. @type {string} */
const INFOWINDOW_SELECTOR = ".smart-info-window, .gm-style-iw-c";

/** @type {ReturnType<typeof setTimeout> | null} */
let closeTimer = null;

/** @returns {void} */
const cancelClose = () => {
    if (closeTimer !== null) {
        clearTimeout(closeTimer);
    }
    closeTimer = null;
};

/**
 * Close the infowindow on every loaded map (only one is ever open from a hover).
 * @returns {void}
 */
const closeInfowindows = () => {
    /** @type {Record<string, any>} */
    const maps = window.oi?.loaded?.map || {};
    Object.values(maps).forEach((mapWrap) => {
        // Same close oilib does on a map click; clearing the position keeps the next open anchored
        mapWrap.infowindow.close();
        mapWrap.infowindow.setPosition?.(null);
    });
    // oifilter.js restores the highlighted pin
    document.dispatchEvent(new CustomEvent("map_infowindow_close"));
};

/** @returns {void} */
const scheduleClose = () => {
    cancelClose();
    closeTimer = setTimeout(closeInfowindows, CLOSE_DELAY_MS);
};

/**
 * True when a mouseout leaves the `selector` element entirely, not just moves between its children.
 * @param {MouseEvent} event
 * @param {string} selector
 * @returns {boolean}
 */
const isLeaving = (event, selector) => {
    const from = event.target instanceof Element ? event.target.closest(selector) : null;
    const to = event.relatedTarget instanceof Node ? event.relatedTarget : null;
    return Boolean(from) && !from.contains(to);
};

// Card hovers open through the marker's mouseover too, so this covers both
document.addEventListener("oimap_marker_mouseover", cancelClose);
document.addEventListener("oimap_marker_mouseout", scheduleClose);

document.addEventListener("mouseover", (event) => {
    if (event.target instanceof Element && event.target.closest(INFOWINDOW_SELECTOR)) {
        cancelClose();
    }
});

document.addEventListener("mouseout", (event) => {
    if (isLeaving(event, ".oi-map-item") || isLeaving(event, INFOWINDOW_SELECTOR)) {
        scheduleClose();
    }
});

// END Map infowindow dismiss
// ========================
